import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as microsoftTeams from "@microsoft/teams-js";
import { addError } from 'actions';
import { getTypes } from 'actions/status';
import { getTranslations, registerLanguages } from 'actions/languages';
import { setLanguage } from 'actions/user';
import { onLanguageChange, setActiveLanguage } from '@haldor/ui';
import { Spinner } from 'UI';
import { appInsights } from 'lib/appInsights';
import { translate } from '@haldor/ui';

var Localization = /*#__PURE__*/function (_Component) {
  _inherits(Localization, _Component);

  var _super = _createSuper(Localization);

  function Localization(props) {
    var _this;

    _classCallCheck(this, Localization);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.timer = setTimeout(function () {
        _this.setState({
          showSession: true
        });
      }, 1000 * 10);
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (prevProps.translations == null && _this.props.translations != null) {
        // Got translations
        if (_this.timer != null) {
          clearTimeout(_this.timer);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "retryFetch", function () {
      if (_this.props.translations == null || _this.props.translations.length == 0) {
        var lcid = localStorage.getItem('language');

        _this.props.getTranslations(lcid);
      } else {
        clearInterval(_this.retryInterval);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isIframe", function () {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.props.registerLanguages();

      onLanguageChange(function (lcid) {
        if (_this.props.translations == null) {
          localStorage.setItem('language', lcid);

          _this.props.getTranslations(lcid).then(function () {
            _this.setState({
              loading: false
            });

            if (_this.props.translations == null || _this.props.translations.length == 0) {
              _this.props.addError(_this.props.translate("You seem to have lost connection to the server. You can keep working as usual while we're trying to reconnect you."), 'info');

              _this.retryInterval = setInterval(_this.retryFetch, 1000 * 15);
            }
          });
        } else {
          // Only fetch new translations if lcid isnt the same as current language in localStorage
          if (localStorage.getItem('language') != lcid) {
            localStorage.setItem('language', lcid);

            _this.props.getTranslations(lcid);

            _this.props.setLanguage(lcid);

            _this.props.getTypes(lcid);
          }

          _this.setState({
            loading: false
          });
        }
      });
      var localLanguage = localStorage.getItem('language');

      if (localLanguage != null) {
        localLanguage = localLanguage.toLowerCase();

        if (localLanguage == 'sv') {
          localLanguage = 'sv-se';
        } else if (localLanguage == 'en') {
          localLanguage = 'en-us';
        } else if (localLanguage == 'nb') {
          localLanguage = 'nb-no';
        } else if (localLanguage == 'nn') {
          localLanguage = 'nn-no';
        }
      }

      if (_this.isIframe()) {
        microsoftTeams.app.getContext().then(function (context) {
          if (context.app.locale == 'sv-se') {
            if (localLanguage != "sv-se") {
              localLanguage = 'sv-se';
            }
          } else if (context.app.locale == 'sv-fi') {
            if (localLanguage != "sv-fi") {
              localLanguage = 'sv-fi';
            }
          } else if (context.app.locale == 'da-dk') {
            if (localLanguage != "da-dk") {
              localLanguage = 'da-dk';
            }
          } else if (context.app.locale == 'nb-no') {
            if (localLanguage != "nb-no") {
              localLanguage = 'nb-no';
            }
          } else if (context.app.locale == 'nn-no') {
            // select bokmål for nynorsk users
            if (localLanguage != "nn-no") {
              localLanguage = 'nn-no';
            }
          } else if (context.app.locale == 'uk') {
            if (localLanguage != "uk") {
              localLanguage = 'uk';
            }
          } else {
            if (localLanguage != "en-us") {
              localLanguage = 'en-us';
            }
          }

          setActiveLanguage(localLanguage);
        });
      } else {
        if (localLanguage == null) {
          var _localLanguage;

          var validLanguages = ['sv-se', 'en-us', 'nn-no', 'nb-no', 'uk'];
          localLanguage = validLanguages.find(function (lang) {
            return lang.indexOf(navigator.language.toLowerCase() || (navigator.userLanguage != null ? navigator.userLanguage.toLowerCase() : "")) > -1;
          });
          localLanguage = (_localLanguage = localLanguage) !== null && _localLanguage !== void 0 ? _localLanguage : 'en-us';
        }

        setActiveLanguage(localLanguage);
      }
    });

    _this.state = {
      loading: true,
      showSession: false
    };
    _this.timer = null;
    _this.retryInterval = null;
    return _this;
  }

  _createClass(Localization, [{
    key: "render",
    value: function render() {
      if (this.state.loading && window.location.pathname != '/lti') {
        return /*#__PURE__*/React.createElement("div", {
          style: {
            textAlign: 'center'
          }
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }), this.state.showSession ? /*#__PURE__*/React.createElement("span", {
          style: {
            color: 'var(--color--meta)'
          }
        }, "Session ID: ", localStorage.getItem('hsid')) : null);
      }

      return this.props.children;
    }
  }]);

  return Localization;
}(Component);

function mapStateToProps(state) {
  return {
    translations: state.Languages.translations,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps, {
  getTranslations: getTranslations,
  setLanguage: setLanguage,
  registerLanguages: registerLanguages,
  getTypes: getTypes,
  addError: addError
})(Localization);